import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  background: #2D1B3D;
  color: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 680px;
  width: 100%;
  border: 1px solid rgba(255, 181, 71, 0.3);
  box-shadow: 0 20px 60px rgba(0,0,0,0.35);
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 28px;
  color: #FFD700;
`;

const P = styled.p`
  margin: 10px 0;
  line-height: 1.6;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const Button = styled.button`
  background: #FF416C;
  background: linear-gradient(135deg, #FF4B2B, #FF416C);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
`;

const SecondaryButton = styled.button`
  background: transparent;
  color: #FFB347;
  border: 1px solid rgba(255, 181, 71, 0.5);
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 600;
  cursor: pointer;
`;

const Hint = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: rgba(255,255,255,0.8);
`;

const PaymentSuccessPage = () => {
  const { t } = useTranslation();
  const { user, isAuthenticated, refreshUser } = useAuth();
  const [checking, setChecking] = useState(false);
  const [activated, setActivated] = useState(false);

  const checkNow = useCallback(async () => {
    try {
      setChecking(true);
      await refreshUser();
    } finally {
      setChecking(false);
    }
  }, [refreshUser]);

  useEffect(() => {
    setActivated(Boolean(user?.isPremium));
  }, [user?.isPremium]);

  return (
    <Page>
      <Card>
        <div style={{ fontSize: 56, marginBottom: 12 }}>🎉</div>
        <Title>{t('paymentSuccess.title')}</Title>
        <P>{t('paymentSuccess.message')}</P>
        {isAuthenticated && (
          <>
            <ButtonRow>
              <Button onClick={checkNow} disabled={checking}>
                {checking ? t('common.loading') : t('paymentSuccess.checkNow', { defaultValue: 'Check premium now' })}
              </Button>
              <SecondaryButton onClick={() => window.location.href = '/'}>
                {t('common.backToMain')}
              </SecondaryButton>
            </ButtonRow>
            <Hint>
              {activated
                ? t('paymentSuccess.activatedHint', { defaultValue: 'Premium is active. You can now use premium features.' })
                : t('paymentSuccess.pendingHint', { defaultValue: 'If not active yet, try again in a minute.' })}
            </Hint>
          </>
        )}
        {!isAuthenticated && (
          <ButtonRow>
            <SecondaryButton onClick={() => window.location.href = '/'}>
              {t('common.backToMain')}
            </SecondaryButton>
          </ButtonRow>
        )}
      </Card>
    </Page>
  );
};

export default PaymentSuccessPage;

